<template>
  <nav id="footer">
    <h1 @click="gotohome">
      <span>Elemax-Tech Engineering</span>
      <img src="@/assets/img/logo.jpg" alt="Logo" />
    </h1>

    <div class="ftInner">
      <div class="col ctInner">
        <!-- Column 1: Quick Links -->
        <div class="con1">
          <h3>Quick Links</h3>
          <ul>
            <li><router-link to="/" class="linkto">Home</router-link></li>
            <li><router-link to="/products" class="linkto">Products</router-link></li>
            <li><router-link to="/services" class="linkto">Services</router-link></li>
            <li v-if="check_spareparts.has_data"><router-link to="/spare-parts" class="linkto">Spare Parts</router-link></li>
            <li><router-link to="/factory" class="linkto">Factory</router-link></li>
			<li v-if="check_projects.has_data"><router-link to="/project-reference" class="linkto">Project Reference</router-link></li>
            <li><router-link to="/about" class="linkto">About</router-link></li>
            <li><router-link to="/contact" class="linkto">Contact</router-link></li>
          </ul>
        </div>

        <!-- Column 2: Sales & Support -->
        <div class="con2">
          <h3>Sales & Support</h3>
          <ul>
            <li v-for="(phone, index) in normalizedPhones" :key="'sales-'+index">
              <span>Sales Hotline:</span> <a :href="'tel:' + phone">{{ phone }}</a>
            </li>
            <li v-for="(phone, index) in normalizedSparePhones" :key="'spare-'+index">
              <span>Spareparts Hotline:</span> <a :href="'tel:' + phone">{{ phone }}</a>
            </li>
            <li><span>Email:</span> <a href="mailto:elemaxtechengineering.ete@gmail.com">elemaxtechengineering.ete@gmail.com</a></li>
            <li><span>Viber:</span> {{ normalizedPhones[0] }}</li>
            <li><span>Hours:</span> Mon–Sat, 9:00 AM – 5:00 PM</li>
          </ul>
        </div>

        <!-- Column 3: Company Information -->
        <div class="con3">
          <h3>Information</h3>
          <ul>
            <li><span>Address:</span> {{ contacts?.address }}</li>
            <li><span>Official Website:</span> <a href="https://elemaxtech.com" target="_blank">www.elemaxtech.com</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="col ctInner">
        <p>© {{ new Date().getFullYear() }} Elemax-Tech Engineering Company Limited. All rights reserved.</p>
        <ul class="col">
          <li><a :href="contacts?.facebook || '#'" target="_blank"><i class="fa-brands fa-facebook"></i></a></li>
          <!-- <li><a :href="contacts?.tiktok || '#'" target="_blank"><i class="fa-brands fa-tiktok"></i></a></li> -->
          <!-- <li><a :href="'viber://chat?number=' + normalizedPhones[0]"><i class="fa-brands fa-viber"></i></a></li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ContentFooter',
  data() {
    return {
		apiBase: process.env.VUE_APP_API_BASE,
		apiToken: process.env.VUE_APP_API_TOKEN,
      contacts: null,
	check_projects: { has_data: false, count: 0 },
	check_spareparts: { has_data: false, count: 0 },
	loading: true,
    };
  },
  computed: {
    normalizedPhones() {
      if (!this.contacts || !this.contacts.phone) return [];
      if (Array.isArray(this.contacts.phone)) return this.contacts.phone;
      try {
        const parsed = JSON.parse(this.contacts.phone);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [this.contacts.phone];
      }
    },
    normalizedSparePhones() {
      if (!this.contacts || !this.contacts.spareparts_phone) return [];
      if (Array.isArray(this.contacts.spareparts_phone)) return this.contacts.spareparts_phone;
      try {
        const parsed = JSON.parse(this.contacts.spareparts_phone);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [this.contacts.spareparts_phone];
      }
    }
  },
  async mounted() {
    try {
	const baseURL = this.apiBase;
      const token = this.apiToken; // your token
      const response = await axios.get(`${baseURL}/api/contacts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.contacts = response.data;
    } catch (error) {
      console.error(error);
    }
	this.fetchCheckProjects();
  },
  methods: {
    gotohome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
	async fetchCheckProjects() {
      try {
        const res = await axios.get(`${this.apiBase}/api/check_projects`, {
          headers: { Authorization: `Bearer ${this.apiToken}` },
        });

		const checkspareparts = await axios.get(`${this.apiBase}/api/check_spareparts`, {
			headers: { Authorization: `Bearer ${this.apiToken}` },
		});

        this.check_projects = res.data; // { has_data: true, count: X }
		this.check_spareparts = checkspareparts.data;
      } catch (err) {
        console.error("Check Projects API Error:", err);
      }
    }
  }
}
</script>
